import { useState, useEffect, useRef } from "react";
//import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import axios from "axios";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import html2canvas from "html2canvas";

const CourseView = () => {
  const URL = process.env.REACT_APP_API_URL;
  const { id } = useParams(); // Get id from the route parameters

  const [course, setCourse] = useState(null);
  const [chapters, setChapters] = useState([]); // Store chapters from API
  const [audiences, setAudiences] = useState([]); // Store audiences from API
  const [customers, setCustomers] = useState([]); // Store customers from API
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [selectedCustomer, setSelectedCustomer] = useState(null); // Selected customer for editing

  // New states for filtering and searching
  const [isApprovedFilter, setIsApprovedFilter] = useState(""); // "true", "false", or ""
  const [searchQuery, setSearchQuery] = useState("");
  
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false); // State for invoice modal
  const [selectedInvoice, setSelectedInvoice] = useState(null); // State for selected invoice
  const invoiceRef = useRef(); // Ref for the invoice content
  // Ensure axios sends cookies (HTTP-only auth cookie)
  axios.defaults.withCredentials = true;

  useEffect(() => {    

    // Fetch the course data
    axios
      .get(`${URL}/courses/${id}`)
      .then((response) => {
        setCourse(response.data.data);
      })
      .catch((error) => {
        toast.error("ไม่สามารถโหลดข้อมูลหลักสูตรได้");
      });

    const fetchChapters = async () => {
      try {
        const response = await axios.get(`${URL}/courses/chapters/${id}`, { withCredentials: true });
        setChapters(response.data.data); // Update chapters state with API data
      } catch (error) {        
      }
    };

    const fetchAudiences = async () => {
      try {
        const response = await axios.get(`${URL}/courses/audiences/${id}`, { withCredentials: true });
        setAudiences(response.data.data); // Update audiences state with API data
      } catch (error) {        
      }
    };

    const fetchCustomers = async () => {
      try {
        const response = await axios.get(`${URL}/customers/courses/${id}`, { withCredentials: true });
        setCustomers(response.data.data); // Update customers state with API data
      } catch (error) {                
      }
    };

    fetchChapters();
    fetchAudiences();
    fetchCustomers();
  }, [URL, id]);

  // Filter and search logic
  const filteredCustomers = customers.filter((customer) => {
    const matchesApproval =
      isApprovedFilter === ""
        ? true
        : customer.isApproved === (isApprovedFilter === "true" ? 1 : 0); // Compare as number (1 or 0)
  
    const matchesSearch =
      customer.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      customer.lastName.toLowerCase().includes(searchQuery.toLowerCase());
  
    return matchesApproval && matchesSearch;
  });

  const handleEdit = (customer) => {
    // Fetch fresh customer data from API
    axios
      .get(`${URL}/customers/${customer.custId}`, { withCredentials: true })
      .then((response) => {
        const freshData = response.data.data;
        setSelectedCustomer({
          ...freshData,
          isCompany: Number(freshData.company && freshData.company !== ""), // Set isCompany based on company field
          needInvoice:
            Number((freshData.taxId && freshData.taxId !== "") ||
            (freshData.address && freshData.address !== "")), // Set needInvoice based on taxId and address
        });
        setIsModalOpen(true); // Open the modal
      })
      .catch((error) => {        
        toast.error("ไม่สามารถดึงข้อมูลลูกค้าได้");
      });
  };

  const handleModalClose = () => {
    setIsModalOpen(false); // Close the modal
    setSelectedCustomer(null); // Clear the selected customer
  };
  
  const handleSave = (e) => {
    e.preventDefault(); // Prevent default form submission    
    if (!selectedCustomer) return;
  
    const formData = new FormData();
    formData.append('firstName', selectedCustomer.firstName);
    formData.append('lastName', selectedCustomer.lastName);
    formData.append('email', selectedCustomer.email);
    formData.append('mobilePhone', selectedCustomer.mobilePhone);
    formData.append('company', selectedCustomer.company || ""); // Optional field
    formData.append('address', selectedCustomer.address || ""); // Optional field
    formData.append('taxId', selectedCustomer.taxId || ""); // Optional field
    formData.append('isCompany', selectedCustomer.isCompany);
    formData.append('needInvoice', selectedCustomer.needInvoice);
    formData.append('isApproved', selectedCustomer.isApproved);
  
    // Add slip file if it exists
    if (selectedCustomer.slip && typeof selectedCustomer.slip !== "string") {
      formData.append('slip', selectedCustomer.slip);         
    }
      
    axios
      .put(`${URL}/customers/${selectedCustomer.custId}`,  formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      })
      .then(() => {        
        setCustomers((prevCustomers) =>
          prevCustomers.map((customer) =>
            //customer.custId === selectedCustomer.custId ? selectedCustomer : customer
            customer.custId === selectedCustomer.custId
                ? { ...selectedCustomer, isApproved: selectedCustomer.isApproved ? 1 : 0 }
                : customer
          )
        );
        toast.success("ปรับปรุงข้อมูลเรียบร้อยแล้ว");
        // Close modal and notify header to refresh pending approvals count
        handleModalClose();
        try {
          window.dispatchEvent(new Event('pending-approvals-updated'));
        } catch (e) {
          // ignore if dispatch fails
        }
      })
      .catch(() => {
        toast.error("ปรับปรุงข้อมูลไม่สำเร็จ");
      });
  };

  const handleDelete = (custId) => {

    toast((t) => (
      <span>
        คุณมั่นใจที่จะลบข้อมูลนี้?
        <div className="mt-2 flex justify-end space-x-2">
        <button
          onClick={() => {
            toast.dismiss(t.id);
            axios.delete(`${URL}/customers/${custId}`, { withCredentials: true })
              .then(() => {
                setCustomers(customers.filter((customer) => customer.custId !== custId));
                toast.success("ลบข้อมูลเรียบร้อยแล้ว");                
                try {
                  window.dispatchEvent(new Event('pending-approvals-updated'));
                } catch (e) {
                  // ignore if dispatch fails
                }
                
              })
              .catch(() => toast.error("ลบข้อมูลไม่สำเร็จ"));
          }}
          className="ml-2 text-red-500"
        >
          ยืนยัน
        </button>
        <button
          onClick={() => toast.dismiss(t.id)} // Dismiss the toast on cancel
          className="ml-2 text-gray-500"
        >
          ยกเลิก
        </button>
        </div>
      </span>
    ));
  };

  const handleShowInvoice = (customer) => {
    setSelectedInvoice(customer); // Set the selected customer for the invoice
    setIsInvoiceModalOpen(true); // Open the invoice modal
  };

  const handleCloseInvoiceModal = () => {
    setIsInvoiceModalOpen(false); // Close the invoice modal
    setSelectedInvoice(null); // Clear the selected invoice
  };

  const handleDownloadPDF = () => {
    const input = invoiceRef.current;
  
    html2canvas(input, {
      scale: 2, // higher scale = better quality
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("invoice.pdf");
    });
  };

    // Format date to YYYY-MM-DD
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };  


  if (!course) {
    return <div>กำลังโหลดข้อมูล...</div>;
  }

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">การจัดการหลักสูตรอบม</h2>
      <hr />

      <nav className="flex mt-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
          <li className="inline-flex items-center">
            <a
              href="/panel/course"
              className="inline-flex items-center font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white"
            >
              <svg
                className="w-3 h-3 me-2.5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
              </svg>
              หลักสูตรอบม
            </a>
          </li>
          <li aria-current="page">
            <div className="flex items-center">
              <svg
                className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="ms-1 font-medium text-gray-500 md:ms-2 dark:text-gray-400">
                แสดงข้อมูล
              </span>
            </div>
          </li>
        </ol>
      </nav>

      <div className="bg-white p-6 rounded-lg shadow-md">
        <img
          src={URL + `/images/course/${course.imageFile}`}
          alt={course.courseTopicTh}
          className="w-full h-80 object-cover rounded-md mb-4"
        />
        <h1 className="text-3xl font-bold mb-4">
          {course.courseTopicTh} ({course.courseTopicEn})
        </h1>
        <p className="text-gray-700 mb-2">
          <strong>วัตถุประสงค์:</strong> {course.objective}
        </p>
        <p className="text-gray-700 mb-2">
          <strong>หัวข้อการอบรม:</strong>
        </p>
        <ul className="list-disc pl-5">
          {chapters.map((chapter, index) => (
            <li key={chapter.chapterId} className="text-gray-700 mb-1">
              บทที่ {index + 1}: {chapter.chapterTitle}
            </li>
          ))}
        </ul>
        <p className="text-gray-700 mb-2">
          <strong>กลุ่มเป้าหมาย:</strong>{" "}
          {audiences.map((audience) => audience.targetAudience).join(", ")}
        </p>

        <p className="text-gray-700 mb-2">
          <strong>รูปแบบการเรียนรู้:</strong>{" "}
          {(() => {
            if (course.learningFormat === 1) {
              return "ออนไซต์";
            } else if (course.learningFormat === 2) {
              return "ออนไลน์";
            } else if (course.learningFormat === 3) {
              return "ออนไซต์และออนไลน์";
            } else {
              return "ไม่ระบุ";
            }
          })()}
        </p>
        <p className="text-gray-700 mb-2">
          <strong>ราคา:</strong> {Number(course?.price)?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "0.00"} THB
        </p>
        <p className="text-gray-700 mb-2">
          <strong>วันที่:</strong>{" "}
          {formatDate(course.traningDate)}
        </p>
        <p className="text-gray-700 mb-2">
          <strong>เวลา:</strong> {course.startTime} - {course.endTime}
        </p>
        <p className="text-gray-700 mb-2">
          <strong>สถานที่:</strong> {course.place}
        </p>
      </div>


      <h2 className="text-lg font-bold mt-6 ml-4 mb-1">รายชื่อผู้ลงทะเบียน:</h2> 
    
      {/* Filter and Search Section */}
      <div className="flex items-center justify-between mt-6 mb-4">
        <div className="flex items-center space-x-4 ml-5">
          <label className="font-medium">สถานะการอนุมัติ:</label>
          <select
            value={isApprovedFilter}
            onChange={(e) => setIsApprovedFilter(e.target.value)}
            className="border border-gray-300 rounded px-4 py-2"
          >
            <option value="">ทั้งหมด</option>
            <option value="true">อนุมัติ</option>
            <option value="false">ไม่อนุมัติ</option>
          </select>
        </div>
        <div className="flex items-center space-x-4">
          <label className="font-medium">ค้นหา:</label>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="ค้นหาชื่อหรือสกุล"
            className="border border-gray-300 rounded px-4 py-2 h-[40px]"
          />
        </div>
      </div>      

      <div className="relative overflow-x-auto shadow-md sm:rounded-lg border-t-2 border-gray-100">
        <table className="w-full text-medium text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-medium text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                    <th scope="col" className="px-6 py-3">
                        ชื่อ-นามสกุล
                    </th>
                    <th scope="col" className="px-6 py-3">
                        อีเมล
                    </th>
                    <th scope="col" className="px-6 py-3">
                        เบอร์โทรศัพท์
                    </th>
                    <th scope="col" className="px-6 py-3">
                        ใบกำกับภาษี
                    </th>                             
                    <th scope="col" className="px-6 py-3 text-center">
                        ดำเนินการ
                    </th>        
                </tr>
            </thead>
            <tbody>
                {filteredCustomers.map((customer) => (
                    <tr key={customer.custId} className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700 border-gray-200">                        
         
                        { customer.isApproved === 1 ? (
                                <td className="px-6 py-2">
                                    <span className="inline-flex items-center px-2 py-1 text-sm font-medium text-green-800 bg-green-100 rounded-full dark:bg-green-900 dark:text-green-300 justify-center">{customer.firstName} {customer.lastName}</span>
                                </td>
                            ) : (
                                <td className="px-6 py-2">
                                    <span className="inline-flex items-center px-2 py-1 text-sm font-medium text-red-800 bg-red-100 rounded-full dark:bg-red-900 dark:text-red-300 justify-center">{customer.firstName} {customer.lastName}</span>
                                </td>
                            )
                        }   
                        <td className="px-6 py-2">
                            {customer.email}
                        </td>

                        <td className="px-6 py-2">
                            {customer.mobilePhone}
                        </td>

                        {(typeof customer.taxId === "string" &&
                            customer.taxId !== "") ||
                            (typeof customer.address === "string" &&
                            customer.address !== "") ? (
                                <td className="px-6 py-2">
                                  <button
                                    id="btnTaxId"
                                    className="text-blue-500 mr-2"
                                    onClick={() => handleShowInvoice(customer)}
                                  >
                                    ออกใบกำกับภาษี
                                  </button>
                                </td>
                            ) : (
                                <td className="px-6 py-2">
                                    -
                                </td>
                            )
                        }

                      <td className="text-center align-middle">
                        <button
                          onClick={() =>  handleEdit(customer)}
                          className="text-green-500 mr-2"
                        >
                          แก้ไข
                        </button>
                        <button
                          onClick={() => handleDelete(customer.custId)}
                          className="text-red-500"
                        >
                          ลบ
                        </button>
                      </td>

                    </tr>
                ))}                              
            </tbody>
        </table>
      </div>


      {/* Modal for Editing Customer */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg w-full max-w-3xl">
            <h2 className="text-lg font-bold mb-4">แก้ไขข้อมูลลูกค้า</h2>
            <form onSubmit={handleSave} className="bg-white p-2 rounded-lg shadow-md border-t-2 border-gray-100">
              <div className="col-span-2">
                <label className="block font-bold mb-2">ประเภทผู้ลงทะเบียน</label>
                <div className="flex items-center gap-6">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="isCompany"
                      value="0"
                      checked={!selectedCustomer.isCompany}
                      onChange={(e) =>
                        setSelectedCustomer({
                          ...selectedCustomer,
                          isCompany: 0,
                          company: "", // Clear company field if switching to personal
                        })
                      }
                      className="mr-2"
                    />
                    บุคคลธรรมดา
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="isCompany"
                      value="1"
                      checked={selectedCustomer.isCompany}
                      onChange={(e) =>
                        setSelectedCustomer({
                          ...selectedCustomer,
                          isCompany: 1,
                        })
                      }
                      className="mr-2"
                    />
                    บริษัท
                  </label>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <input
                  type="text"
                  name="firstName"
                  value={selectedCustomer.firstName ?? ""}
                  onChange={(e) =>
                    setSelectedCustomer({
                      ...selectedCustomer,
                      firstName: e.target.value,
                    })
                  }
                  placeholder="ชื่อจริง"
                  className="p-2 border rounded h-[38px]"
                  required
                />
                <input
                  type="text"
                  name="lastName"
                  value={selectedCustomer.lastName ?? ""}
                  onChange={(e) =>
                    setSelectedCustomer({
                      ...selectedCustomer,
                      lastName: e.target.value,
                    })
                  }
                  placeholder="นามสกุล"
                  className="p-2 border rounded h-[38px]"
                  required
                />
                <input
                  type="email"
                  name="email"
                  value={selectedCustomer.email ?? ""}
                  onChange={(e) =>
                    setSelectedCustomer({
                      ...selectedCustomer,
                      email: e.target.value,
                    })
                  }
                  placeholder="อีเมล"
                  className="p-2 border rounded h-[38px]"
                  required
                />
                <input
                  type="text"
                  name="mobilePhone"
                  value={selectedCustomer.mobilePhone ?? ""}
                  onChange={(e) =>
                    setSelectedCustomer({
                      ...selectedCustomer,
                      mobilePhone: e.target.value,
                    })
                  }
                  placeholder="เบอร์โทรศัพท์"
                  className="p-2 border rounded h-[38px]"
                  required
                />

                {Number(selectedCustomer.isCompany)===1 && (
                  <>
                    <input
                      type="text"
                      name="company"
                      value={selectedCustomer.company ?? ""}
                      onChange={(e) =>
                        setSelectedCustomer({
                          ...selectedCustomer,
                          company: e.target.value,
                          isCompany: Number(e.target.value !== ""), // Set isCompany based on company field
                        })
                      }
                      placeholder="ชื่อบริษัท"
                      className="p-2 border rounded h-[38px]"
                      required
                    />
                  </>
                )}

                <div className="col-span-2">
                  <label className="block font-bold mb-2">ต้องการใบกำกับภาษีหรือไม่</label>
                  <div className="flex items-center gap-6">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="needInvoice"
                        value="0"
                        checked={!selectedCustomer.needInvoice}
                        onChange={(e) =>
                          setSelectedCustomer({
                            ...selectedCustomer,
                            needInvoice: 0,
                            taxId: "", // Clear taxId and address if switching to no invoice
                            address: "",
                          })
                        }
                        className="mr-2"
                      />
                      ไม่ต้องการ
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="needInvoice"
                        value="1"
                        checked={selectedCustomer.needInvoice}
                        onChange={(e) =>
                          setSelectedCustomer({
                            ...selectedCustomer,
                            needInvoice: 1,
                          })
                        }
                        className="mr-2"
                      />
                      ต้องการ
                    </label>
                  </div>
                </div>

                {Number(selectedCustomer.needInvoice)===1 && (
                  <>
                    <input
                      type="text"
                      name="address"
                      value={selectedCustomer.address ?? ""}
                      onChange={(e) =>
                        setSelectedCustomer({
                          ...selectedCustomer,
                          address: e.target.value,
                          needInvoice:
                            Number(e.target.value !== "" ||
                            selectedCustomer.taxId !== ""), // Set needInvoice based on address and taxId
                        })
                      }
                      placeholder="ที่อยู่"
                      className="p-2 border rounded h-[38px]"
                      required
                    />
                    <input
                      type="text"
                      name="taxId"
                      value={selectedCustomer.taxId ?? ""}
                      onChange={(e) =>
                        setSelectedCustomer({
                          ...selectedCustomer,
                          taxId: e.target.value,
                          needInvoice:
                            Number(e.target.value !== "" ||
                            selectedCustomer.address !== ""), // Set needInvoice based on taxId and address
                        })
                      }
                      placeholder="เลขประจำตัวผู้เสียภาษี"
                      className="p-2 border rounded h-[38px]"
                      required
                    />
                  </>
                )}

                <div className="col-span-2">            
                  <label className="block font-bold mb-2">ไฟล์รูปภาพ</label>
                  <div className="flex items-center gap-4">
                  {selectedCustomer.slip && typeof selectedCustomer.slip === "string" && (
                    <a
                      href={`${URL}/images/slip/${selectedCustomer.slip}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline font-medium"
                    >
                      ดูรูปสลิป
                    </a>
                  )}

                  <input
                    type="file"
                    name="slip"
                    onChange={(e) =>
                      setSelectedCustomer({ ...selectedCustomer, slip: e.target.files[0] })
                    }
                    className="border border-gray-300 rounded px-4 py-2 h-[38px] text-sm"
                    accept="image/*"
                  />
                  </div>
                </div>
              </div>

              <div className="col-span-2">
                <label className="block font-bold mb-2">อนุมัติการสมัคร</label>
                <div className="flex items-center gap-6">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="isApproved"
                      value="0"
                      checked={!selectedCustomer.isApproved}
                      onChange={(e) =>
                        setSelectedCustomer({
                          ...selectedCustomer,
                          isApproved: 0
                        })
                      }
                      className="mr-2"
                    />
                    ไม่อนุมัติ
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="isApproved"
                      value="1"
                      checked={selectedCustomer.isApproved}
                      onChange={(e) =>
                        setSelectedCustomer({
                          ...selectedCustomer,
                          isApproved: 1
                        })
                      }
                      className="mr-2"
                    />
                    อนุมัติ
                  </label>
                </div>
              </div>

              <div className="flex justify-end space-x-4 mt-4">
                <button
                  type="button"
                  onClick={handleModalClose}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded h-[38px] text-sm"
                >
                  ยกเลิก
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-500 text-white rounded h-[38px] text-sm"
                >
                  บันทึก
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      
      {/* Invoice Modal */}
      {isInvoiceModalOpen && selectedInvoice && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4"> {/* Added padding */}
           {/* Increased max-width, added overflow-y-auto */}
          <div className="bg-white p-5 rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center border-b pb-2 mb-4">
                 <h2 className="text-xl font-semibold">ใบกำกับภาษี/ใบเสร็จรับเงิน</h2> {/* More specific title */}
                 <button onClick={handleCloseInvoiceModal} className="text-gray-400 hover:text-gray-600">&times;</button> {/* Close button */}
            </div>

            {/* --- Content to be printed/downloaded --- */}
            {/* Attach the ref to the specific content container */}
            <div ref={invoiceRef} className="bg-white p-6 border border-gray-200 rounded-lg mb-4 printable-content"> {/* Added class for potential CSS targeting */}
               {/* Simple Invoice Layout Example */}
               <div className="text-center mb-6">
                    <h3 className="text-lg font-bold">ใบกำกับภาษี / ใบเสร็จรับเงิน</h3>
                    <p className="text-sm">เลขที่: INV-{selectedInvoice.custId}-{new Date().toISOString().slice(0,10)}</p> {/* Example invoice number */}
               </div>
               <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
                    <div>
                        <h4 className="font-semibold mb-1">ข้อมูลลูกค้า:</h4>
                        {
                            selectedInvoice.company !=="" ? (
                                <p><strong>บริษัท:</strong> {selectedInvoice.company}</p>
                            ) : (
                                <p><strong>ชื่อ:</strong> {selectedInvoice.lastName}</p>
                            )
                        }                        
                        <p><strong>ที่อยู่:</strong> {selectedInvoice.address || "-"}</p>
                        <p><strong>เลขประจำตัวผู้เสียภาษี:</strong> {selectedInvoice.taxId || "-"}</p>
                        <p><strong>อีเมล:</strong> {selectedInvoice.email}</p>
                        <p><strong>โทรศัพท์:</strong> {selectedInvoice.mobilePhone}</p>
                    </div>
                     <div className="text-right">
                        <h4 className="font-semibold mb-1">ผู้ออก:</h4>
                        <p>บริษัท เอไอ บิสซิเนส เทคโนโลยี จำกัด</p>
                        <p>5/443 ถนนประชาชื่น แขวงบางซื่อ เขตบางซื่อ กรุงเทพมหานคร 10800</p>
                        <p>0105568071186</p>
                        <p>วันที่ออก: {new Date().toLocaleDateString('th-TH')}</p>
                    </div>
               </div>
               <div className="mb-4">
                <table className="w-full text-sm border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 p-2 text-left">รายการ</th>
                      <th className="border border-gray-300 p-2 text-right">จำนวนเงิน (บาท)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 p-2">ค่าลงทะเบียนหลักสูตร {course?.courseTopicTh}</td>
                      <td className="border border-gray-300 p-2 text-right">
                      {(Number(course?.price) / 1.07).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                   
                    <tr>
                      <td className="border border-gray-300 p-2 text-right">ภาษีมูลค่าเพิ่ม 7%:</td>
                      <td className="border border-gray-300 p-2 text-right">
                        {(Number(course?.price) - (Number(course?.price) / 1.07)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                    <tr className="font-semibold">
                      <td className="border border-gray-300 p-2 text-right">รวมทั้งสิ้น:</td>
                      <td className="border border-gray-300 p-2 text-right">
                        {Number(course?.price)?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "0.00"}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>


               <p className="text-xs text-center text-gray-500 mt-6">เอกสารนี้ออกโดยระบบอัตโนมัติ</p>
            </div>
            {/* --- End of Content --- */}

            <div className="flex justify-end space-x-3 pt-4 border-t"> {/* Add separator */}
              
              <button
                 onClick={handleDownloadPDF}
                 className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 text-sm font-medium"
              >
                 ดาวน์โหลด PDF
              </button>
              <button
                 onClick={handleCloseInvoiceModal}
                 className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 text-sm font-medium"
              >
                 ปิด
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default CourseView;